import { createStyledContext, styled, View, withStaticProperties } from "@tamagui/core";
import { Icon, StyledIcon } from "../Icon/Icon.mjs";
import { Typography } from "../Typography/Typography.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const CalloutContext = createStyledContext({
    variant: "neutral"
  }),
  CalloutFrame = styled(View, {
    alignItems: "flex-start",
    context: CalloutContext,
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    borderRadius: "$callout.default",
    borderWidth: 1,
    defaultVariants: {
      variant: "neutral"
    },
    flexDirection: "row",
    gap: "$callout.gap",
    justifyContent: "space-between",
    overflow: "visible",
    padding: "$callout.padding",
    variants: {
      variant: {
        error: {
          backgroundColor: "$callout.error.background",
          borderColor: "$callout.error.border"
        },
        information: {
          backgroundColor: "$callout.information.background",
          borderColor: "$callout.information.border"
        },
        neutral: {
          backgroundColor: "$callout.neutral.background",
          borderColor: "$callout.neutral.border"
        },
        warning: {
          backgroundColor: "$callout.warning.background",
          borderColor: "$callout.warning.border"
        }
      }
    }
  }),
  CalloutIcon = styled(StyledIcon, {
    context: CalloutContext,
    size: "regular",
    variants: {
      variant: {
        error: {
          color: "$callout.error.icon",
          icon: "forbidden"
        },
        information: {
          color: "$callout.information.icon",
          icon: "information"
        },
        neutral: {
          color: "$callout.neutral.icon",
          icon: "question"
        },
        warning: {
          color: "$callout.warning.icon",
          icon: "warning"
        }
      }
    }
  }),
  CalloutWithContext = withStaticProperties(CalloutFrame, {
    Icon: CalloutIcon,
    props: CalloutContext.Provider
  });
function Callout({
  action,
  children,
  variant = "neutral",
  withIcon = !0,
  ...props
}) {
  return /* @__PURE__ */jsxs(CalloutWithContext, {
    variant,
    children: [withIcon ? /* @__PURE__ */jsx(View, {
      children: /* @__PURE__ */jsx(CalloutWithContext.Icon, {})
    }) : null, /* @__PURE__ */jsxs(View, {
      flex: 1,
      gap: "$space.8",
      children: [/* @__PURE__ */jsx(View, {
        children
      }), action]
    }), props.dismissible ? /* @__PURE__ */jsx(View, {
      cursor: "pointer",
      onPress: props.onDismiss,
      children: /* @__PURE__ */jsx(Icon, {
        color: "$grey.700",
        icon: "cross",
        size: 12
      })
    }) : null]
  });
}
const Title = props => /* @__PURE__ */jsx(Typography.Text, {
    bold: !0,
    size: "small",
    variant: "primary",
    ...props
  }),
  Content = props => /* @__PURE__ */jsx(Typography.Text, {
    size: "tiny",
    variant: "secondary",
    ...props
  }),
  Action = ({
    children,
    disabled = !1,
    onPress
  }) => /* @__PURE__ */jsxs(View, {
    alignItems: "center",
    alignSelf: "flex-start",
    animation: "textInput",
    borderBottomColor: disabled ? "$text-disabled" : "$text-primary",
    borderBottomWidth: 1,
    cursor: "pointer",
    disabled,
    flexDirection: "row",
    gap: "$space.4",
    group: !0,
    hoverStyle: {
      borderBottomColor: "$text-secondary"
    },
    onPress,
    pressStyle: {
      borderBottomColor: "$text-secondary"
    },
    children: [/* @__PURE__ */jsx(Typography.Text, {
      "$group-hover": {
        variant: "secondary"
      },
      "$group-press": {
        variant: "secondary"
      },
      animation: "textInput",
      bold: !0,
      size: "tiny",
      variant: disabled ? "disabled" : "primary",
      children
    }), /* @__PURE__ */jsx(Icon, {
      "$group-hover": {
        color: "$text-secondary"
      },
      "$group-press": {
        color: "$text-secondary"
      },
      color: disabled ? "$text-disabled" : "$text-primary",
      icon: "arrow-right",
      size: 12
    })]
  });
Callout.Title = Title;
Callout.Title.displayName = "Callout.Title";
Callout.Content = Content;
Callout.Content.displayName = "Callout.Content";
Callout.Action = Action;
Callout.Action.displayName = "Callout.Action";
export { Callout };
//# sourceMappingURL=Callout.mjs.map
